import Employee from './modules/EmployeeApi'
import EmployeeRole from './modules/EmployeeRoleApi'
import RefillStock from './modules/RefillStockApi'
import Status from './modules/StatusApi'
import Stock from './modules/StockApi'
import SystemFlag from './modules/SystemFlagApi'
import User from './modules/UserApi'
import DataExport from './modules/export/DataExportApi'

import FinancialsApi from '@/_backoffice/_financial/api/index.js'
import RegistrationsApi from '@/_backoffice/_registrations/api/index.js'

export default {
  ...FinancialsApi,
  ...RegistrationsApi,

  Employee,
  EmployeeRole,
  DataExport,
  RefillStock,
  Status,
  Stock,
  SystemFlag,
  User,
}
